import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

/* eslint-disable */
export default new createVuetify({
  components,
  directives,
  theme: {
    dark: false,
    options: {
      customProperties: true
    },
    themes: {
      light: {
        colors: {
          primary: '#9B124F', // A
          'primary-darken1': '#9B124F', // R
          'primary-lighten1': '#FFCCCC', // C
          primaryBtnText: '#FFFFFF', // A'
          secondary: '#E28900', // B
          'secondary-darken1': '#754700', // D
          secondaryBtnText: '#FFFFFF', // B'
          headerBack: '#EE1132', // E
          headerText: '#FFFFFF', // F
          logoutBtnText: '#FFFFFF', // G
          topSchoolNamePc: '#EE1132', // H
          topSecondaryBtn: '#FF0619', // I
          topSecondaryBtnText: '#FFFFFF', // J
          topPrimaryBtn: '#CF001C', // K
          topPrimaryBtnText: '#FFFFFF', // L
          topBtnUpText: '#FFFFFF', // M
          primaryOutLineBtnText: '#9C0000', // N
          secondaryOutLineBtnText: '#E28900', // O
          topBtnUpTextSp: '#9B124F', // P
          topBtnBackSp: '#FFFFFF', // Q'
          eventHeaderBack: '#9B124F',
          eventHeaderText: '#FFFFFF',
          eventTopBorderSub: '#9B124F',
          accent: '#162988', // datepickerなどの色
          formBackground: '#F6f6f6',
          'error-lighten3': '#ffa99e',
          'error-darken1': '#df323b',
          'error-darken2': '#bf0025',
          'error-darken3': '#9f0010',
          'success-darken1': '#2d9437',
          'success-darken2': '#00791e',
          'success-darken3': '#006000',
          'info-darken3': '#004d9f',
          'info-lighten3': '#95e8ff'
          
        }
      },
      dark: {
        colors: {
          primary: '#FF5252',
          secondary: '#43A047',
          accent: '#162988',
          formBackground: '#F6f6f6'
        }
      }
    }
  },
  date: {
    formats: {
      dayOfMonth: (date) => date.getDate()
    }
  }
})
